import { LinkType } from "model/Links";
import styled, { css } from "styled-components";
import { FlexRow } from "styles/layout";

// filter generated via https://codepen.io/sosuke/pen/Pjoqqp
const getIconHoverFilter = (type: LinkType | undefined) => {
  switch (type) {
    case "Discord":
      //#5865f2
      return css`
        filter: invert(47%) sepia(67%) saturate(5867%) hue-rotate(224deg)
          brightness(99%) contrast(92%);
      `;
    case "Twitch":
      //#9047ff
      return css`
        filter: brightness(0) saturate(100%) invert(31%) sepia(79%)
          saturate(3076%) hue-rotate(248deg) brightness(100%) contrast(104%);
      `;
    case "X":
      // Keep Black
      return css``;
    case "YouTube":
      //#fe0100
      return css`
        filter: brightness(0) saturate(100%) invert(31%) sepia(91%)
          saturate(6491%) hue-rotate(353deg) brightness(89%) contrast(127%);
      `;
    default:
      //#3cb371 - MediumSeaGreen
      return css`
        filter: invert(65%) sepia(42%) saturate(605%) hue-rotate(94deg)
          brightness(84%) contrast(88%);
      `;
  }
};
export const LinksContainer = styled(FlexRow)`
  column-gap: 5px;
`;

export const IconContainer = styled.div<{ type?: LinkType }>`
  width: 25px;
  height: 21px;
  padding: 4px 2px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    cursor: pointer;
    transform: scale(105%);
    ${({ type }) => getIconHoverFilter(type)}
  }
`;

export const IconImage = styled.img`
  max-width: 100%;
  max-height: 100%;
`;
